<!--Copy right - © 2024 tecera gmbh-->
<script>
    export let toggle_variable;
    export let toggle_label_0;
    export let toggle_label_1;

</script>

<div class="segmented-control">
    <div
        class={!toggle_variable ? "segment active" : "segment not-active"}
        on:click={() => {
            if (toggle_variable) toggle_variable = !toggle_variable;
        }}
        on:keypress={(e) => {
            if (e.key === "Enter") {
                if (toggle_variable) toggle_variable = !toggle_variable;
            }
        }}
    >
        {toggle_label_0}
    </div>
    <div
        class={toggle_variable ? "segment active" : "segment not-active"}
        on:click={() => {
            if (!toggle_variable) toggle_variable = !toggle_variable;
        }}
        on:keypress={(e) => {
            if (e.key === "Enter") {
                if (!toggle_variable) toggle_variable = !toggle_variable;
            }
        }}
    >
        {toggle_label_1}
    </div>
</div>
